export const INSTANT_CHECKOUT_BUTTON_SUBMISSION =
  'instant-checkout-page-button';
export const INSTANT_CHECKOUT_OVERLAY = 'instant-checkout-page-modify-overlay';
export const INSTANT_CHECKOUT_PAGINATION = 'instant-checkout-pagination';
export const INSTANT_CHECKOUT_SUCCESS = 'instant-checkout-page-update-success';
export const POST_PAGE_ERROR = 'instant-checkout-post-page-error';
export const INSTANT_CHECKOUT_CONTINUE_SHOPPING_LINK =
  'instant-checkout-continue-shopping';
export const INSTANT_CHECKOUT_ENROLLMENT_SUCCESS =
  'instant-checkout-enrollment-success';

export const INSTANT_CHECKOUT_POST_PAGE_ERROR =
  'instant-checkout-post-page-error';
